import React, { useMemo } from 'react';

import cx from 'classnames';

import Button from 'components/shared/Button';
import Table from 'components/shared/Table';

import { TruncatedText } from '../../../shared';
import { useEditGuestPortal, useEnterPortal } from '../functions';
import { Pagination } from '../Pagination';
import { IEnterPortalModalProps } from '../types';
import s from './index.module.css';

export const EnterPortalTable = ({ guestPortals }: Pick<IEnterPortalModalProps, 'guestPortals'>) => {
  const { handleEditGuestPortal } = useEditGuestPortal();
  const { itemsPerPage, currentPage, startIndex, endIndex, handlePageChange } = useEnterPortal();
  const currentItems = guestPortals.slice(startIndex, endIndex);

  const columns = useMemo(
    () => [
      {
        Header: 'Guest Portal',
        accessor: 'consultantName',
        className: s.name,
        Cell: ({ row }: any) => {
          const icon = <span className={cx(s.gpIcon, row?.original?.parentId && s.greyGpIcon)}>GP</span>;
          return (
            <span className={cx(s.proposalText)}>
              {icon} <span style={{ margin: '5px' }}>-</span> <TruncatedText text={row?.original?.title} lines={2} />
            </span>
          );
        },
      },
      {
        Header: 'Internal Guest Portal Notes',
        accessor: 'archiveReason',
        className: s.notes,
        Cell: ({ row }: any) => {
          return <span>{row?.original?.notes || row?.original?.consultant?.email}</span>;
        },
      },
      {
        Header: 'Actions',
        accessor: 'dates',
        className: s.actions,
        Cell: ({ row }: any) => {
          return (
            <Button className={cx(s.modalButton)} type="default" onClick={() => handleEditGuestPortal(row?.original)}>
              Edit
            </Button>
          );
        },
      },
    ],
    [handleEditGuestPortal],
  );

  return (
    <div>
      {/*@ts-ignore*/}
      <Table tableClassName={s.table} theadClassName={s.tableHead} columns={columns} data={currentItems} />
      {guestPortals.length > itemsPerPage && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={guestPortals.length}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};
